import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));

export const Route = createFileRoute("/admin/")({
  component: () => <AdminDashboard />,
});
